module.exports = __webpack_public_path__ + "img/copy_fill_ico.4802615c.svg";